import { render, staticRenderFns } from "./NewIncident.vue?vue&type=template&id=23f29d40&"
import script from "./NewIncident.vue?vue&type=script&lang=js&"
export * from "./NewIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports